function myFunctions() {
  function filterImgVariantOnLoad() {
    if(window.innerWidth > 720) {
      const featuredImages = document.querySelectorAll('figure.product-gallery--media img');
      const featuredImg = document.querySelector('figure.product-gallery--media[data-gallery-selected="true"] img');
      let featuredAlt = "";
      if(featuredImg) {
       featuredAlt = featuredImg.alt; 
      }
      
      Array.from(featuredImages).forEach(img => {
        if(img.alt.toLowerCase() === featuredAlt.toLowerCase() || img.alt.toLowerCase() === "all" || featuredAlt.toLowerCase() === "all") {
          img.parentNode.parentNode.style.display = "block";
          console.log(img.alt.toLowerCase())
          console.log(featuredAlt.toLowerCase())
        } else {
          img.parentNode.parentNode.style.display = "none";
        }
      })
    }
  }
  filterImgVariantOnLoad()
  //variant-selection .options-selection__option-value-label .options-selection__option-value-label
  //const optionSelectors = document.querySelectorAll('.options-selection__swatches .options-selection__option-swatch-wrapper');
  const optionSelectors = document.querySelectorAll('.variant-selection .options-selection__option-value-label span');
  Array.from(optionSelectors).forEach(selector => {
    selector.addEventListener('click', function(e) {
      setTimeout(filterImgVariantOnLoad, 100);
    });
  })
}
window.onload=myFunctions

/* document.addEventListener('DOMContentLoaded', function() {
  const popup = document.getElementById('newsletter-popup');
  const closeButton = document.querySelector('.close-button');
  const cookieName = 'popupShown';
  const cookieExpiryDays = 30;

  function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
  }

  function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length, c.length);
      }
    }
    return null;
  }

  function showPopup() {
    popup.style.display = 'block';
  }

  function hidePopup() {
    popup.style.display = 'none';
    setCookie(cookieName, 'true', cookieExpiryDays);
  }

  // Check if the cookie exists when the page loads
  if (getCookie(cookieName) === null) {
    // If the cookie doesn't exist, show the popup after a short delay (optional)
    setTimeout(showPopup, 1000); // Adjust the delay in milliseconds as needed
  }

  // Add event listener to the close button
  closeButton.addEventListener('click', hidePopup);

  // Optional: Close the popup if the user clicks outside the popup content
  window.addEventListener('click', function(event) {
    if (event.target === popup) {
      hidePopup();
    }
  });
}); */